/*----------------------------------
- MENU EDITION DATE
----------------------------------*/

const EDITION_DATE_KEY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const EDITION_DATE_FORMAT = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
});

/**
 * "16 Sep" from a `YYYY-MM-DD` edition key, or null when Product sent none.
 *
 * Formatted in UTC on purpose: an edition key is the UTC day the edition closed, so
 * reading it in the visitor's zone would date yesterday's edition as the day before.
 * A key that is not a real date returns null, and the Market panel drops its line.
 */
export const formatMenuEditionDate = (dateKey: string | undefined): string | null => {
    if (!dateKey || !EDITION_DATE_KEY_PATTERN.test(dateKey)) return null;

    const date = new Date(`${dateKey}T00:00:00.000Z`);
    if (Number.isNaN(date.getTime())) return null;

    return EDITION_DATE_FORMAT.format(date);
};
